var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27352 11.8686C11.2906 11.8686 14.547 9.40106 14.547 6.35725C14.547 4.92624 13.8273 3.62261 12.6471 2.64289L12.663 2.62998C12.8778 2.4564 12.8778 2.17497 12.663 2.00139C12.4483 1.8278 12.1001 1.8278 11.8853 2.00139L11.8194 2.05468C10.5742 1.29835 8.99356 0.845947 7.27352 0.845947C3.25646 0.845947 0 3.31344 0 6.35725C0 7.78834 0.719846 9.09202 1.90014 10.0718L1.88422 10.0846C1.66945 10.2582 1.66945 10.5396 1.88422 10.7132C2.09898 10.8868 2.44718 10.8868 2.66195 10.7132L2.72787 10.66C3.97304 11.4162 5.55356 11.8686 7.27352 11.8686ZM2.72787 10.66L12.6471 2.64289C12.3918 2.43101 12.1151 2.23427 11.8194 2.05468L1.90014 10.0718C2.15539 10.2836 2.43217 10.4804 2.72787 10.66Z",
    fill: "#0D3A91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.6db44a9e8659bc3a002ccc42c98e1402.svg";
export { ForwardRef as ReactComponent };